import { render, staticRenderFns } from "./dui-locale-string.vue?vue&type=template&id=270ee795&"
import script from "./dui-locale-string.vue?vue&type=script&lang=js&"
export * from "./dui-locale-string.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports